cv.Pledge = Backbone.RESTModel.extend({
  defaults: {
    amount: 0,
  },

  saveMap: {},

  urlRoot: function () {
    return `${cv.new_api_path}/donations`;
  },

  initialize: function () {
    console.log("Donaations v2 model initialized.");
  },
});
Cocktail.mixin(cv.Pledge, cv.mixins.SyncModel);

// Donations Collection
cv.Pledges = Backbone.Collection.extend({
  initialize: function () {
    console.log("Donations v2 collection initialized.");
  },

  url: function () {
    return `${cv.new_api_path}/donations?${$.param(this.params)}`;
  },

  model: cv.Pledge,
});
Cocktail.mixin(cv.Pledges, cv.mixins.PaginateModel);
